export const orderHistoryEventTypes = {
    call: 'Звонок',
    created: 'Создание',
    deleted: 'Удаление',
    restore: 'Восстановление',
    status: 'Статус',
    sync: 'Синхронизация',
    sms: 'СМС',
    ttn: 'ТТН',
    update_product: 'Обновление',
    packing: 'Упаковка',
    comment: 'Комментарий',
    file: 'Файл',
    assign_bank_transaction: 'Оплата',
    unassign_bank_transaction: 'Оплата',
    pipeline: 'Пайплайн',
};

export const orderHistoryEventNames = {
    call: 'call',
    created: 'created',
    deleted: 'deleted',
    status: 'status',
    sync: 'sync',
    sms: 'sms',
    ttn: 'ttn',
    update_product: 'update_product',
    packing: 'packing',
    comment: 'comment',
    file: 'file',
    assign_bank_transaction: 'assign_bank_transaction',
    unassign_bank_transaction: 'unassign_bank_transaction',
    pipeline: 'pipeline',
};
